import {
  loginUrl,
  recoverPassword,
  recoverPasswordCurrent,
  resetPasswordAccount,
} from "@config/urls.config";
import axios from "axios";

export const login = async (data, setAuthData) => {
  try {
    const response = await axios.post(loginUrl, data, {
      withCredentials: true,
      headers: {
        "X-Client-Type": "web",
      },
    });

    if (response.data.user.permissions.hasOwnProperty("SPR617")) {
      const suppliersPermissions = response.data.user.permissions.SPR617;
      setAuthData(
        response.data.expires_in,
        response.data.token,
        suppliersPermissions,
        response.data.user
      );
      return response.data;
    } else {
      return {
        success: false,
        message: "You do not have permissions to access this application",
      };
    }
  } catch (error) {
    return error?.response?.data;
  }
};
export const resetPassword = async (token, data, setResponse) => {
  try {
    setResponse({ loading: true, error: false, success: false });
    const response = await axios.post(resetPasswordAccount, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setResponse({ loading: false, error: false, success: true });
    return response.data.message;
  } catch (error) {
    console.error("Error changing password:", error);
    setResponse({ loading: false, error: true, success: false });
    return error.response.data.message;
  }
};
export const recoverPasswordEmail = async (data, token) => {
  try {
    const response = await axios.post(recoverPassword, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      success: response.data.success,
      data: response.data.message,
    };
  } catch (error) {
    console.error("Error recover password:", error);
    return {
      success: response.data.success,
      data: error.response.data.message,
    };
  }
};
export const recoverPasswordVerify = async (url, data) => {
  try {
    const response = await axios.post(url, data);
    return { success: response.data.success, data: response.data.message };
  } catch (error) {
    console.error("Error recover process password:", error);
    return {
      success: response.data.success,
      data: error.response.data.message,
    };
  }
};
export const changePassword = async (token, data) => {
  try {
    const response = await axios.post(recoverPasswordCurrent, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { success: response.data.success, data: response.data.message };
  } catch (error) {
    console.error("Error recover process password:", error);
    return {
      success: response.data.success,
      data: error.response.data.message,
    };
  }
};
export const logout = async (clearAuthData) => {
  clearAuthData();
};